import {unloadOneType} from "./unload_one_type.js";

export function unloadArchived(entityName, dispatch, sessions, filterFunc) {
  const combinedFilter = (filterFunc)
    ? ((e) => e?.archivedAt || filterFunc(e))
    : ((e) => e?.archivedAt);

  unloadOneType(entityName, dispatch, sessions, combinedFilter);
}
